import { append } from "./append";
import { Selection } from "./selection";
import { Suggestions } from "./suggestions";
import { toProgram } from "./toProgram";
import { toSource } from "./toSource";

type Result = {
  source: string;
  selection: Selection;
};

export const applySuggestion = (source: string, selection: Selection, suggestions: Suggestions, value: string): Result => {
  const program = toProgram(source);

  append(program, selection, suggestions, value);

  const nextSource = toSource(program);

  /**
   * We should move the input selection position to the end of the insertion as that is probably where the user wants to start typing.
   */
  const nextStart = selection.start + nextSource.slice(selection.start).indexOf("}");

  const nextSelection = {
    start: nextStart,
    end: nextStart,
  };

  return {
    source: nextSource,
    selection: nextSelection,
  };
};
